module.exports = __webpack_public_path__ + "static/media/mild_spicy.996cc51a.png";